<template>
<!-- 我创建或者负责的项目合同 -->
    <div class="contain desPro-con">
        <div class="header-box">
          <div>
               <span>项 目 筛 选：</span>
                 <el-select v-model="search.entProjectId" clearable placeholder="请选择" class="tqmInfo-val" @change="doFilter">
                    <el-option
                      v-for="item in projectsList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
                    </el-option>
                  </el-select>
           </div>
           <div>
               <span>类 型 筛 选：</span>
                 <el-select v-model="search.unitKind" clearable placeholder="请选择" class="tqmInfo-val" @change="doFilter">
                    <el-option
                      v-for="item in unitKinds"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
          </div> 
          <div>
              <span>合 同 名 称:</span>
                <el-input placeholder="请输入合同名称" v-model="search.contractName" style="width:12vw;"></el-input>
          </div>
            <div style="width:300px">
             <el-button type="primary" class="add-user" @click="addFun">合同创建</el-button>
          </div>
                
        </div>
        <div class="box">
            <div class="build-bar">
             <div>
                <span>合同编号：</span>
                <el-input placeholder="请输入合同编号" v-model="search.serialNum " style="width:12vw;"></el-input>
             </div>
              <div>
                <span>合同负责人：</span>
                <el-input placeholder="请输入合同负责人" v-model="search.principal " style="width:12vw;"></el-input>
             </div>   
               <div>
                <span>  创建者:</span>
                <el-input placeholder="请输入创建者" v-model="search.createBy" style="width:12vw;"></el-input>
             </div>   
             <div style="width:300px">
                <el-button type="primary" class="add-user" @click="doFilter" >查询</el-button>
                <el-button type="primary" plain class="add-user" @click="addFun">导出</el-button>
                <el-button type="primary" plain  class="add-user" @click="clear">清除条件</el-button>
             </div>   
            </div>
            <div class="box-content">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                        <!-- <el-table-column type="expand">
                         <template slot-scope="props">
                           <el-form label-position="left" inline class="demo-table-expand">
                               <el-form-item label="所属项目:" style="width:100%;text-align:left;display:flex">
                                   <span style="color:#409EFF;">{{props.row.entProjectName}}</span>
                               </el-form-item>
                             <el-form-item label="前期阶段:" style="width:100%;text-align:left;display:flex">
                                <span  style="margin-right:10px">中标单位:
                                    <span  v-if="props.row.proTenderBase"> {{ props.row.proTenderBase.selectDept||'暂无'}}</span> 
                                    <span v-else>暂无</span>
                                    </span>
                                <span style="margin-right:10px">合同开工时间:
                                    <span v-if="props.row.proTenderBase">{{ props.row.proTenderBase.contractStartDate||''}}</span>
                                    <span v-else>暂无</span>
                                </span>
                                <span style="margin-right:10px">合同竣工时间:
                                    <span v-if="props.row.proTenderBase">{{ props.row.proTenderBase.contractEndDate||''}}</span>
                                    <span v-else>暂无</span>
                                </span>
                                <span style="margin-right:10px">合同价:
                                    <span v-if="props.row.proTenderBase">{{ props.row.proTenderBase.contractPrice||''}}万元</span>
                                    <span v-else>暂无</span>
                                </span>
                                <span style="margin-right:10px">合同工期:
                                    <span v-if="props.row.proTenderBase">{{ props.row.proTenderBase.otherDay||''}}</span>
                                    <span v-else>暂无</span>
                                </span>
                             </el-form-item>
                             <el-form-item label="建设验收阶段" style="width:100%;text-align:left;">
                                <span  style="margin-right:10px">开工令时间:
                                    <span  v-if="props.row.proBuilding"> {{ props.row.proBuilding.startDate||''}}</span> 
                                    <span v-else>暂无</span>
                                    </span>
                                    <span  style="margin-right:10px">应完成时间:
                                    <span  v-if="props.row.proBuilding"> {{ props.row.proBuilding.finishDate||''}}</span> 
                                    <span v-else>暂无</span>
                                    </span>
                                <span  style="margin-right:10px">工期剩余时间:
                                    <span  v-if="props.row.proBuilding"> {{ props.row.proBuilding.restDay||''}}</span> 
                                    <span v-else>暂无</span>
                                </span>
                             </el-form-item>
                            <el-form-item label="支付阶段:" style="width:100%;text-align:left;">
                                <span  style="margin-right:10px">预付款:
                                  <span style="color:#f00" v-if="props.row.proPay.advanceCharge"> {{ props.row.proPay.advanceCharge.total1||0}}万元</span> 
                                  <span  v-else>暂无</span>
                                </span>
                                <span  style="margin-right:10px">初审款:
                                  <span style="color:#f00" v-if="props.row.proPay.first"> {{ props.row.proPay.first.total2||0}}万元</span> 
                                  <span  v-else>暂无</span>
                                </span>
                                 <span  style="margin-right:10px">终审款:
                                 <span style="color:#f00" v-if="props.row.proPay.finall"> {{ props.row.proPay.finall.total5||0}}万元</span> 
                                  <span  v-else>暂无</span>
                                </span>
                                 <span  style="margin-right:10px">质保款:
                                 <span style="color:#f00" v-if="props.row.proPay.quality"> {{ props.row.proPay.quality.total4||0}}万元</span> 
                                  <span  v-else>暂无</span>
                                </span>
                            </el-form-item>
                             <el-form-item label="移交决算阶段:" style="width:100%;text-align:left;">
                                <span  style="margin-right:10px">建设工程档案移交书:
                                  <span style="color:#f00"  v-if="props.row.proTransitionphase">( {{ count||0}})</span> 
                                  <span v-else>暂无</span>
                                </span>
                                <span  style="margin-right:10px"><span v-if="props.row.proTransitionphase && props.row.proTransitionphase.materialobjectInfo && props.row.proTransitionphase.materialobjectInfo.list.length!=0">{{props.row.proTransitionphase.materialobjectInfo.list[0].time}}</span>实物移交时间以及移交表:
                                  <span style="color:#f00"  v-if="props.row.proTransitionphase">( {{ count1||0}})</span> 
                                  <span v-else>暂无</span>
                                </span>
                                <span  style="margin-right:10px"><span v-if="props.row.proTransitionphase && props.row.proTransitionphase.wordTrade&&props.row.proTransitionphase.wordTrade.list.length!=0">{{props.row.proTransitionphase.wordTrade.list[0].time}}</span>国资移交时间及移交表:
                                  <span style="color:#f00"  v-if="props.row.proTransitionphase">( {{ count2||0}})</span> 
                                  <span v-else>暂无</span>
                                </span>
                             </el-form-item>
                             <el-form-item label="维保阶段:" style="width:100%;text-align:left;">
                                <span  style="margin-right:10px">验收报告:
                                  <span style="color:#f00" v-if="props.row.proMaintent && props.row.proMaintent.monthCheck &&props.row.proMaintent.monthCheck.list.length>0"> ({{ props.row.proMaintent.monthCheck.list[0].files.length||'暂无'}})</span> 
                                  <span v-else>暂无</span>
                                </span>
                             </el-form-item>    
                              
                             <div class="caozuo">
                                <el-button size="mini" type="primary"  @click="handleDelte(props.$index, props.row)">删除</el-button>
                                <el-button size="mini" type="primary" plain @click="modeFun(props.$index, props.row)">修改</el-button>    
                                <el-button size="mini" type="primary" plain @click="handleEdit(props.$index, props.row)">信息填报</el-button>
                              </div>
                           </el-form>
                         </template>
                       </el-table-column> -->
                    <el-table-column label="序号" width="60" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位类型" width="140" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.unitKindName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同名称" width="150" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号" width="140" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.serialNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="负责人" fixed>
                        <template slot-scope="scope">
                          <span>{{ scope.row.principal }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" width="120" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建者" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.createName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="工程类型" fixed width="140">
                        <template slot-scope="scope">
                            <span>{{ scope.row.projectTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="前期完成率" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.settlementPercentage }}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="建设验收完成率" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.biddingPercentage }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付完成率" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.payPercentage }}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="移交决算完成率" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.movePercentage }}</span>
                        </template>
                    </el-table-column>
                        <el-table-column label="维保完成率" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.maintenancePercentage}}</span>
                        </template>
                    </el-table-column>
                  <!-- <el-table-column label="统计">
                        <template slot-scope="scope">
                            <span>{{ scope.row.statisticsPercentage}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" width="240" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" plain @click="handleEdit(scope.$index, scope.row)">信息填报</el-button>
                            <el-button size="mini" type="success" plain @click="modeFun(scope.$index, scope.row)">修改</el-button>
                            <el-button size="mini" type="danger"  @click="handleDelte(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[3, 5, 10, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                    style="padding-top:10px;"
                ></el-pagination>
            <!-- 弹出框 -->           
                <el-dialog
                    :title="diaTitle"
                    :visible.sync="addFormVisible"
                    width="500px"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                >
                    <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px" :label-position="labelPosition">
                        <el-form-item label="合同名称：" prop="name">
                            <el-input v-model="addForm.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="项目" prop="entProjectId">
                           <el-select v-model="addForm.entProjectId" @change="getTotalContracts" placeholder="请选择" class="tqmInfo-val">
                             <el-option
                               v-for="item in projects"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                             </el-option>
                           </el-select>
                        </el-form-item>
                         <el-form-item label="合同编号:" prop="serialNum">
                            <el-input v-model="addForm.serialNum" autocomplete="off">
                             <el-button slot="append" type="mini" @click="auto">生成编号</el-button>     
                            </el-input>
                        </el-form-item>         
                        <el-form-item label="单位种类：" prop="unitKind" >
                           <el-radio v-model="addForm.unitKind" label="1" @change="changeType">项目采购类</el-radio>
                           <el-radio v-model="addForm.unitKind" label="2" @change="changeType">管理服务类</el-radio>
                        </el-form-item>
                         <el-form-item label="单位类型:">
                           <el-select v-model="addForm.unitType" placeholder="请选择" class="tqmInfo-val">
                             <el-option
                               v-for="item in unitTypes"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                             </el-option>
                           </el-select>
                        </el-form-item>
                        <!-- <el-form-item v-if="addForm.unitType!=''&&addForm.unitType!='2'" label="总包单位合同编号：" prop="totalSerialNum">
                            <el-select v-model="addForm.totalSerialNum" placeholder="请选择" class="tqmInfo-val">
                                <el-option
                                v-for="item in totalContracts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.serialNum">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="合同负责人" prop="principal">
                           <el-select v-model="addForm.principal" placeholder="请选择" class="tqmInfo-val">
                             <el-option
                               v-for="item in projects1"
                               :key="item.userId"
                               :label="item.name"
                               :value="item.userId">
                             </el-option>
                           </el-select>
                        </el-form-item>
                        <el-form-item label="合同概况:">
                            <el-input type="textarea" :rows="2" v-model="addForm.overview" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="备注:">
                            <el-input type="textarea" :rows="2" v-model="addForm.description" autocomplete="off"></el-input>
                        </el-form-item>
                        
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            count:0,
            count1:0,
            count2:0,
            search:{
                contractName:'',
                entProjectId:'',
                serialNum:'',//合同编号
                unitKind:'', //类型筛选
                principalId:util.session.get('user').id,//负责人
                createBy:'',//创建人
            },
            listData:[],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            diaTitle:"",
            labelPosition: 'right',
            dataText:"数据加载中...",
            projects:[],
            addFormVisible:false,
            addForm: {
                id:'',
                name:'',
                entId:'',
                entProjectId:'',
                serialNum:'',//合同编号
                unitKind:'',
                principal:'',//合同负责人
                description:'',//备注
                overview:'',
                unitType:'',
                totalSerialNum:''
            },
             rules:{
                name: [{ required: true, message: '请输入合同名称', trigger: 'blur' } ],
                serialNum:[{ required: true, message: '请输入合同编号', trigger: 'blur' } ],
                unitKind:[{ required: true, message: '请选择单位种类', trigger: 'blur' } ],
            },
            unitKinds:[{label:'项目采购类',value:'1'},{label:'管理服务类',value:'2'}],
            unitTypes:[],
            projects:[],
            projects1:[],
            projectsList:[],
            totalContracts:[],  //总包合同列表
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.addForm.entId=this.groupId

        this.getData()
        this.getProject(2)
        // this.getTotalContracts()
    },
    methods:{
        //获取总包合同列表
        getTotalContracts(){
            var that = this
            myHttp.selectContractByEntId({
                entId:this.groupId,
                entProjectId:this.addForm.entProjectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.contractInfo||[]
                    // that.totalContracts = list
                    if(list.length>0){
                        that.addForm.totalSerialNum = list[0].serialNum
                    }else{
                        that.addForm.totalSerialNum = ''
                    }
                }
            })
        },
        doFilter(){
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            // this.search.contractName = this.contractName
            this.search.entId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            myHttp.selectContractInfoPage(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.contractPageInfo.list; //
                    for(var i=0;i<list.length;i++){
                        list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        // console.log(list[i].index)
                        list[i].proPay.advanceCharge = that.filetJson(list[i].proPay.advanceCharge)
                        list[i].proPay.finall=that.filetJson(list[i].proPay.finall)
                        list[i].proPay.first=that.filetJson(list[i].proPay.first)
                        list[i].proPay.quality=that.filetJson(list[i].proPay.quality)
                        if(list[i].proMaintent){
                            list[i].proMaintent.monthCheck = that.filetJson(list[i].proMaintent.monthCheck)
                            console.log(list[i].proMaintent.monthCheck)
                        }
                    
                        list[i].proBuilding.restDay =list[i].proBuilding.finishDate&&''!=list[i].proBuilding.finishDate?util.myTime.getdayByDate(new Date(),list[i].proBuilding.finishDate):'暂无'
                            
                        //建设工程档案移交书(技术处)
                        if(list[i].proTransitionphase){
                            list[i].proTransitionphase.conproArchive = that.filetJson(list[i].proTransitionphase.conproArchive)
                            
                            list[i].proTransitionphase.materialobjectInfo = that.filetJson(list[i].proTransitionphase.materialobjectInfo)

                            list[i].proTransitionphase.wordTrade = that.filetJson(list[i].proTransitionphase.wordTrade)
                        }
                    
                        if( list[i].proTransitionphase &&list[i].proTransitionphase.conproArchive){
                            var listpro = list[i].proTransitionphase.conproArchive.list
                            if(listpro){
                                for(var x = 0;x<listpro.length;x++){
                                    var count = listpro[x].files.length            
                                }
                                that.count = count
                            }
                        }
                        if(list[i].proTransitionphase&& list[i].proTransitionphase.materialobjectInfo){
                            var materialobjectInfo =  list[i].proTransitionphase.materialobjectInfo.list
                            if(materialobjectInfo){
                                for(var k = 0;k<materialobjectInfo.length;k++){
                                    var count1=0
                                    if(k==0){
                                        count1 = materialobjectInfo[k].files.length 
                                    }else{
                                        count1 += materialobjectInfo[k].files.length        
                                    }                
                                }
                            }
                    
                            that.count1 = count1
                            if(list[i].proTransitionphase&&list[i].proTransitionphase.wordTrade){
                                var wordTrade =list[i].proTransitionphase.wordTrade.list
                                if(wordTrade){
                                    for(var j = 0;j<wordTrade.length;j++){
                                        var count2=0
                                        if(j==0){
                                        count2 = wordTrade[j].files.length 
                                        }else{
                                        count2 += wordTrade[j].files.length        
                                        }            
                                    }
                                }
                                that.count2 = count2
                            }
                        }
                        if(list[i].proTenderBase && list[i].proTenderBase.contractStartDate && list[i].proTenderBase.contractEndDate){
                            list[i].proTenderBase.otherDay = util.myTime.getdayByDate(list[i].proTenderBase.contractStartDate,list[i].proTenderBase.contractEndDate)                 
                        }else{
                            list[i].proTenderBase.otherDay = '暂无'
                        }
                    }
                    that.listData = list;
                    that.totalItems = resp.data.data.contractPageInfo.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },

        //解析方法
        filetJson(obj){
            // console.log(obj instanceof Object)
            // console.log(typeof obj == 'string')
            if(typeof obj === 'string'){  //typeof obj == 'string'
                if(obj.indexOf('[')>-1||obj.indexOf('{')>-1){
                    return JSON.parse(obj)
                }else{
                    return obj
                }
            }
           
        },
        //添加list
        addList(obj){
            // var result = {}
            if(!obj){
                obj = {
                    list:[]
                }
                obj.list.push({files:[]})
            }else if(obj.list.length==0){
                obj.list.push({files:[]})
            }
            // result = obj
            // return obj
        },
    
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            util.session.set('principalId',row.principalId)
              util.session.set('unitKind',row.unitKind)
            this.$router.push('/purHead/'+row.contractId)
        },
        // 新增的数据
        sumbitAddRow(formName) {
            var that = this;
            if(this.addForm.unitType!='2'&&this.addForm.totalSerialNum =='' ){
                that.$message.error("请先添加施工总包合同！");
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(that.addForm.id==''){
                       that.addForm.createBy =util.session.get('user').id
                        myHttp.createInfoContract(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    }else{
                      that.addForm.updateBy =util.session.get('user').id
                        myHttp.updateInfoContract(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("修改成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    }
                }
            });
        },
        //新增
        addFun(){
            this.addForm.id = ''
            this.addForm.name = ''
            this.addForm.entProjectId = ''
            this.addForm.serialNum = ''
            this.addForm.unitKind = ''
            this.addForm.principal = ''
            this.addForm.description=''//备注
            this.addForm.overview=''
            this.addForm.unitType=''
            this.addForm.totalSerialNum = ''
            this.addFormVisible = true
            this.diaTitle = '创建合同'
            this.getProject(1)
            this.getPerson()
        },
        //修改
        modeFun(index,row){
            this.addFormVisible = true
            this.addForm.id = row.contractId
            this.addForm.entProjectId=row.entProjectId
             this.addForm.entId = row.entId
            this.addForm.name = row.contractName
            this.addForm.serialNum = row.serialNum
            this.addForm.unitKind = row.unitKind
             this.addForm.unitType=row.unitType
            this.addForm.principal=row.principal
            this.addForm.description=row.description
            this.addForm.totalSerialNum = row.totalSerialNum
            this.addForm.overview=row.overview
            this.diaTitle = '修改合同'
            this.getUnit(row.unitKind)
            this.getProject()
            this.getPerson()
        },
        /**清除条件 */
        clear(){
         this.search={
                name:'',
                entProjectId:'',
                serialNum:'',//合同编号
                unitKind:'', //类型筛选
                principal:'',//负责人
                createBy:'',//创建人
         }
          this.getData()
        },
        // 改变
        changeType(e){
         this.getUnit(e)
        },
        /**获取单位类型 */
        getUnit(e){
          var that = this
          if(e==1){
           myHttp.getDictByType({
                    type: 'projetUnitType'
                  })
                  .then(function(resp) {
                    if (resp.data.code == '200') {
                      var list = resp.data.data.dictList || []
                      that.unitTypes =list
                    }
                  })
           }else{
              myHttp.getDictByType({
                    type: 'mangeUnitType'
                  })
                  .then(function(resp) {
                    if (resp.data.code == '200') {
                      var list = resp.data.data.dictList || []
                      that.unitTypes =list
                    }
                  })
           }
          },
          /**获取项目列表 */
         getProject(index){
          var that =this
           myHttp.getEntProjectListNoPage({
                  groupId:this.groupId 
              })
                  .then(function(resp) {
                    if (resp.data.code == '200') {
                       var list = resp.data.data.entProject||[]
                       if(index==1){
                      that.projects =list
                       }else{
                        that.projectsList =list
                       }
                     
                      console.log(that.projects)
                    }
                  })
         },
        /**获取负责人 */
        getPerson(){
           var that =this
           myHttp.selectEntPersonList({
                   entId:this.groupId 
              })
                  .then(function(resp) {
                    if (resp.data.code == '200') {
                       var list = resp.data.data.entPersonList||[]
                      that.projects1 =list
                    }
                  })
        },
        handleDelte(index,row){
          var that = this
                     this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then(() => {
                         myHttp.deleteInfoContract({
                             id: row.contractId,
                             updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getData()
                    } else {
                    that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        /**shanchu */
       auto() {
      console.log(111)
      // var date = new Date();
      // var year = date.getFullYear().toString();
      // var month = (date.getMonth()+1).toString();
      // var day = date.getDate().toString();
      // var hour = date.getHours().toString();
      // var minute = date.getMinutes().toString();
      // var second = date.getSeconds().toString();
      // var time = year+month+day+hour+minute+second
      var str = this.randomString(8)
      this.addForm.serialNum = 'TS' + str
    },
        randomString(len, charSet) {
      charSet = charSet || '0123456789'
      var randomString = ''
      for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length)
        randomString += charSet.substring(randomPoz, randomPoz + 1)
      }
      return randomString
    },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* font-size: 18px; */
        /* color: #2058D9; */
    }
    .box{
        /* margin-top: 15px; */
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 140px );
        background: #fff;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
         justify-content: space-between;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
 .el-form-item__label{
     color: inherit;
 }
    
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    /* .el-table td, .el-table th{
        text-align: center;
    } */
    .caozuo{
        display: flex;
        justify-content: flex-end;
    }
    /* .el-dialog{
        width: 500px;
    } */
    .desPro-con .el-input__inner{
        border: 1px solid #DCDFE6;
    }
    /* .desPro-con .el-table .cell{
        text-align: left;
    } */
    @import '../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>